import { makeStyles } from 'tss-react/mui';

type Props = { fullWidth?: boolean; color: string };

export const useStyles = makeStyles<Props>({ name: 'Alert' })((theme, props) => ({
  alert: {
    width: (props.fullWidth ? 'auto' : 'fit-content'),

    border: `1px solid ${theme.palette[props.color]?.main || ''}`,

    '& svg': {
      color: `${theme.palette[props.color]?.main || ''}`,
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 330,
    },
  },
  alertTitle: {
    fontWeight: 'bold',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.4px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  alertDesc: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.4px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  iconContaier: {
    display: 'flex',
    alignItems: 'start',
  },
}));
